import styled from 'styled-components';

export const HeadContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 32px;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		align-items: normal;
		flex-direction: column;
		gap: 16px;
	}
`;

export const TitlePage = styled.h1`
	align-items: baseline;
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	font-size: 32px;
	font-weight: 500;
	line-height: 1.1;

	svg {
		height: 40px;
		margin-right: 16px;
		width: 40px;
	}
`;

export const ContainerButton = styled.div`
	display: flex;
	gap: 12px;
	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
		width: 100%;
	}
`;

interface ButtonHeadProps {
	variant: 'pure' | 'abell';
}

export const ButtonHead = styled.button<ButtonHeadProps>`
	background: ${({ theme, variant }) =>
		(variant === 'abell' && theme.colors.principal.abell) ||
		(variant === 'pure' && theme.colors.principal.pure)};
	border: ${({ theme, variant }) =>
		(variant === 'abell' && 'none') ||
		(variant === 'pure' && `1px solid ${theme.colors.principal.ceres}`)};
	border-radius: 8px;
	color: ${({ theme, variant }) =>
		(variant === 'abell' && theme.colors.principal.pure) ||
		(variant === 'pure' && theme.colors.principal.abell)};
	cursor: pointer;
	padding: 9.5px 14px;

	&:hover {
		opacity: 0.7;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;
